import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent, services } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedin, FaLeaf } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom'; 
 
const Footer = () => {   
  
  return (
    <footer className='footer'>
      
      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Transforming outdoor spaces with premium gardening and landscaping solutions.</p> {/* Description for the about section */}

          {/* Filtering out the contact with id 4 and displaying the remaining contact info */}
          <div className='info connect'>
            {contactContent
              .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
              .map((contact) => {
                return (
                  <p key={contact.id}>
                    <span className='icon'>{contact.icon}</span>
                    {contact.content[0]} {/* Only show the first value from content */}
                  </p>
                );
              })}
          </div>

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Services Links Section */}
        <div className='footer-item'> 

          <h2>Our Services</h2>

          <div className='info links'> 
            {/* Mapping through the services and creating links to each service page */}
            {services.map(service => {
              /* Link to the individual service page */
              return <p key={service.id}><FaLeaf className='icon' /> 
                <Link
                  to={{ 
                    pathname: '/Services/' + service.title, // Dynamically constructing the link path
                  }}
                  location={{service}} // Passing service data to the route
                  state={service} // Passing service data in state
                >
                  {service.title}  {/* Display Service Title */}
                </Link>
              </p>
            })}
          </div>
        </div>

        {/* Useful Links Section */}
        <div className='footer-item'> 

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaLeaf className='icon' /><Link to='/about-us'>about</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Services'>Services</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Projects'>Projects</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Blog-list'>blogs</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Shop-list'>shop</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>

        </div>

        {/* Contact Info Section */}
        <div className='footer-item'>

          <h2>Newsletter</h2>
          <p>Stay informed and up-to-date with the latest trends, helpful tips, and exclusive special offers.</p>

          {/* Newsletter component to subscribe */}
          <Newsletter variant='dark' idPrefix='2' />

        </div>

      </div>
 
      <div className='content'>
        {/* Footer content with copyright information */}
        <p>designed by <span>AS_Designs</span> | all rights reserved</p>
      </div>
      
    </footer>
  )
}

export default Footer;